import { parse } from 'tldts';
import { environment } from "../../../environments/environment";
import { allLanguages } from "./languages";
const countryArrya = require('../../../assets/json/regions-to-countries.json');

export enum SwapStatus {
  not_started = 0,
  in_progess = 1,
  complete = 2,
  failed = 3,
  rejected = 4,
  approval_pending = 5,
  confirm_pending = 6,
  wert_inprogress = 7,
}

export const wertLangs: Record<string, string> = {
  en: 'en',
  fr: 'fr',
  ja: 'ja',
  es: 'es',
  kr: 'ko',
  'zh-hans': 'zh',
  'zh-hant': 'zh',
};

export enum CTAStatus {
  none,
  eth,
  usdt,
  transak,
}

export function getCookie(name: string) {
  if (typeof document === 'undefined') return undefined;
  let matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function setCookie(name: string, value: any) {
  if (typeof document === 'undefined') return;
  document.cookie = name + '=' + value + ';max-age=15778462';
}

export function getReferrer(): string {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return '';
  }

  const params = new URLSearchParams(window.location.search);

  const pid = params.get('pid');
  const tid = params.get('tid');

  const referrer = document.referrer;

  // ---------------------------------
  // 1. Partner Traffic
  // ---------------------------------
  if (pid) return `Partner${pid}`;
  if (tid) return `Partner${tid}`;

  // ---------------------------------
  // 2. Direct Traffic
  // ---------------------------------
  if (!referrer) return 'Direct';

  try {
    // ---------------------------------
    // 3. Android App Referrers
    // ---------------------------------
    if (referrer.startsWith('android-app://')) {
      const app = referrer
        .replace('android-app://', '')
        .replace(/\/$/, '')
        .toLowerCase();

      if (app.includes('line.android')) return 'Line';
      if (app.includes('google')) return 'Google';
      if (app.includes('reddit')) return 'Reddit';
      if (app.includes('facebook')) return 'Facebook';
      if (app.includes('instagram')) return 'Instagram';
      if (app.includes('telegram')) return 'Telegram';
      if (app.includes('twitter') || app.includes('x')) return 'X/Twitter';

      return 'App';
    }

    // ---------------------------------
    // 4. Parse URL
    // ---------------------------------
    const parsedUrl = new URL(referrer);
    const host = parsedUrl.hostname.toLowerCase();

    // ---------------------------------
    // 5. Ignore Self Referrals
    // Replace with your real domains
    // ---------------------------------
    const domain = environment.domain;
    const appDomain = new URL(domain).hostname.toLowerCase();

    if (
      host === appDomain ||
      host.endsWith('.' + appDomain)
    ) {
      return 'Direct';
    }
    // ---------------------------------
    // 6. Short Link Domains
    // ---------------------------------
    if (host === 't.co' || host.endsWith('.t.co')) {
      return 'X/Twitter';
    }

    if (host === 't.me' || host.endsWith('.t.me')) {
      return 'Telegram';
    }

    // ---------------------------------
    // 7. Extract Root Domain using tldts
    // ---------------------------------
    const result = parse(host);

    const root = (result.domainWithoutSuffix || '').toLowerCase();

    if (!root) return 'Direct';

    // ---------------------------------
    // 8. Brand Mapping
    // ---------------------------------
    const map: Record<string, string> = {
      google: 'Google',
      bing: 'Bing',
      yahoo: 'Yahoo',
      duckduckgo: 'DuckDuckGo',
      yandex: 'Yandex',
      naver: 'Naver',

      twitter: 'X/Twitter',
      x: 'X/Twitter',

      telegram: 'Telegram',
      line: 'Line',

      facebook: 'Facebook',
      fb: 'Facebook',
      instagram: 'Instagram',
      reddit: 'Reddit',
      linkedin: 'LinkedIn',
      pinterest: 'Pinterest',
      quora: 'Quora',
      trustpilot: 'Trustpilot'
    };

    if (map[root]) return map[root];

    // ---------------------------------
    // 9. Generic Search Engines
    // ---------------------------------
    const searchEngines = [
      'google',
      'bing',
      'yahoo',
      'duckduckgo',
      'yandex',
      'naver'
    ];

    if (searchEngines.includes(root)) {
      return 'Organic Search';
    }

    // ---------------------------------
    // 10. Generic Social
    // ---------------------------------
    const socials = [
      'facebook',
      'twitter',
      'x',
      'instagram',
      'reddit',
      'linkedin',
      'telegram',
      'pinterest',
      'line'
    ];

    if (socials.includes(root)) {
      return 'Social';
    }

    // ---------------------------------
    // 11. Default Humanized Output
    // ---------------------------------
    return root.charAt(0).toUpperCase() + root.slice(1);

  } catch {
    return 'Direct';
  }
}

export function getParam(paramName: string) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return '';
  let urlParams = new URLSearchParams(document.location.search);
  let param: string | undefined = getCookie(paramName);

  if (urlParams.get(paramName)) {
    // always take clickId from URL if present
    param = urlParams.get(paramName) as string;
    document.cookie = paramName + '=' + param + ';max-age=15778462';
  }
  return param ? param : '';
}

export function handleLastClickTracking(paramNames: string[]): Record<string, string> {
  const result: Record<string, string> = {};
  if (typeof window === 'undefined') return result;

  const urlParams = new URLSearchParams(document.location.search);
  const hasParamInUrl = paramNames.some((name) => urlParams.has(name));
  // If any tracking param is in the URL — override everything
  if (hasParamInUrl) {
    for (const paramName of paramNames) {
      const value = urlParams.get(paramName) || ''; // set to '' if missing
      document.cookie = `${paramName}=${value}; max-age=15778462; path=/`;
      result[paramName] = value;
    }
  } else {
    // Use cookie values from previous session
    for (const paramName of paramNames) {
      result[paramName] = getCookie(paramName) || '';
    }
  }
  return result;
}

export function getParamWithoutCookie(paramName: string) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return '';
  let urlParams = new URLSearchParams(document.location.search);
  let param;
  if (urlParams.get(paramName)) {
    // always take clickId from URL if present
    param = urlParams.get(paramName);
  }

  return param ? param : '';
}

export function getBrowserName() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return 'other';
  const agent = window.navigator.userAgent.toLowerCase();
  switch (true) {
    case agent.indexOf('edge') > -1:
      return 'edge';
    case agent.indexOf('opr') > -1 && !!(<any>window).opr:
      return 'opera';
    case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
      return 'chrome';
    case agent.indexOf('trident') > -1:
      return 'ie';
    case agent.indexOf('firefox') > -1:
      return 'firefox';
    case agent.indexOf('safari') > -1:
      return 'safari';
    default:
      return 'other';
  }
}

export const getCountryFromTimeZone = () => {
  if (typeof Intl === 'undefined') return 'Unknown';
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return countryArrya[timeZone] || 'Unknown';
  } catch {
    return 'Unknown';
  }
};

export function verifyLanguage(lang: string): boolean {
  const validLang = allLanguages.filter((x) => x.value === lang);
  return validLang.length > 0 ? true : false;
}

export function convertNum(value: number, decimals: number = 2) {
  const num = Math.floor(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  let nf = new Intl.NumberFormat('en-US', { maximumFractionDigits: decimals });
  return nf.format(num); // "1,234,567,890"
}

export function convertDecimal(value: number, decimals: number = 2) {
  return Math.floor(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
}

export const faqItems = [
  {
    heading: 'faq.faq_1',
    content: 'faq.faq_cont_1',
  },
  {
    heading: 'faq.faq_2',
    content: 'faq.faq_cont_2',
  },
  {
    heading: 'faq.faq_3',
    content: 'faq.faq_cont_3',
  },
  {
    heading: 'faq.faq_4',
    content: 'faq.faq_cont_4',
  },
  {
    heading: 'faq.faq_5',
    content: 'faq.faq_cont_5',
  },
];

export const isSafari = () => {
  if (typeof navigator === 'undefined') return false;
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  return isSafari
}

export enum WalletConnectionModes {
  BEST_WALLET_MOB = 'bw',
  BEST_WALLET = 'walletBW',
  WALLET_CONNECT = 'wallet',
  METAMASK = 'metamask',
  COINBASE = 'coinbase',
}

export enum CHAINS {
  EVM = "evm",
  SOL = "sol"
}

function isMobile() {
  if (typeof navigator === 'undefined') return false;
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || '');
  return check;
}

function isMobileTablet() {
  if (typeof navigator === 'undefined') return false;
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || '');
  return check;
}

export const getUserDevice = () => {
  return isMobileTablet() ? 'tablet' : isMobile() ? 'mobile' : 'web';
};
